var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgE1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.82 30.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-E1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.94,28.63c-1,0-3.5-.26-4.2.15.23.5-.07.29.52.71.16.12.44.32.63.44a4.81,4.81,0,0,0,1.63.54,4.61,4.61,0,0,0,3.35-.84c1.93-1.42-.43-1-1.93-1Z",
    transform: "translate(0 0)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86,17.47c-.35,5.3-4.2,6.66-3.84,8.38s9.16,1,11.28,1L23.56,27c6.07.05,1-3.17-.14-6.4-.07-.21-.14-.42-.2-.62A10.79,10.79,0,0,1,14.83,4.31a9.06,9.06,0,0,0-8.6,3.14c-2.82,3.34-2.05,5.22-2.37,10Z",
    transform: "translate(0 0)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.63,0a9.19,9.19,0,1,1-9.19,9.19A9.19,9.19,0,0,1,24.63,0Z",
    transform: "translate(0 0)",
    fill: "#ed7333",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE1);
export default __webpack_public_path__ + "static/media/E1.540d2253afaf4d3864feb9acba778027.svg";
export { ForwardRef as ReactComponent };